import { makeStyles, tokens } from '@fluentui/react-components';

export const useConversationItemStyles = makeStyles({
  timeLabel: {
    display: 'block',
    fontSize: '16px',
    color: tokens.colorNeutralForeground3,
    padding: '8px 16px 8px',
    fontWeight: tokens.fontWeightBold,
    margin: '12px 0px 0px 0px',
  },
  divider: {
    marginBottom: '8px',
  },
  wrapper: {
    position: 'relative',
    width: '100%',
    height: '44px',
    minHeight: 'fit-content',
    boxSizing: 'border-box',
  },
  wrapperHovered: {
    backgroundColor: tokens.colorNeutralBackground2Hover,
    zIndex: 3,
    borderLeft: '3px solid #0F6CBD',
  },
  activeItem: {
    borderLeft: '3px solid #0F6CBD',
    zIndex: 3,
  },
  listItemWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    flex: 1,
  },
  listItem: {
    width: '100%',
    cursor: 'pointer',
    outline: 'none',
    padding: '6px 16px',
    fontSize: tokens.fontSizeBase300,
    color: '#444444',
    fontWeight: tokens.fontWeightRegular,
  },
  listItemHovered: {
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorNeutralForeground2,
  },
  listContainer: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    maxHeight: 'calc(100% - 59px)',
    overflowY: 'auto',
    backgroundColor: tokens.colorNeutralBackground2,
  },
  textContent: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    paddingRight: '40px',
  },
  textContentHovered: {
    fontWeight: tokens.fontWeightBold,
    color: tokens.colorNeutralForeground2,
  },
  moreOptionsContainer: {
    opacity: 0,
    transition: 'opacity 0.2s ease-in-out',
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
  },
  visible: {
    opacity: 1,
  },
  input: {
    width: 'calc(100% - 32px)',
    margin: '0 16px',
    boxSizing: 'border-box',
  },
  inputError: {
    borderTopColor: `${tokens.colorStatusDangerForeground1} !important`,
    borderBottomColor: `${tokens.colorStatusDangerForeground1} !important`,
    borderLeftColor: `${tokens.colorStatusDangerForeground1} !important`,
    borderRightColor: `${tokens.colorStatusDangerForeground1} !important`,
  },
  inlineError: {
    color: tokens.colorStatusDangerForeground1,
    size: tokens.fontSizeBase200,
    margin: '0 16px',
  },
});

export const useChatHistoryViewStyles = makeStyles({
  resumeConversationLoading: {
    height: '100%',
  },
  contentNavRefresh: {
    backgroundColor: tokens.colorNeutralBackground2,
  },
});

export const useNoConversationsViewStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '90%',
    textAlign: 'center',
  },
  title: {
    fontWeight: tokens.fontWeightBold,
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground1,
    marginTop: tokens.spacingVerticalS,
    marginBottom: 0,
  },
  subtitle: {
    fontWeight: tokens.fontWeightRegular,
    fontSize: tokens.fontSizeBase100,
    color: tokens.colorNeutralForeground3,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    marginBottom: tokens.spacingVerticalS,
    marginTop: 0,
  },
  button: {
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground1,
    fontWeight: tokens.fontWeightRegular,
  },
});


export const chatHistoryTeachingBubbleStyles = makeStyles({
  header: {
    fontSize: tokens.fontSizeBase400,
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: tokens.spacingVerticalS,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  image: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: tokens.spacingVerticalS,
  },
  bubble: {
    '& .ms-TeachingBubble-footer': {
      justifyContent: 'right',
    },
  },
});
